import React, { useEffect } from 'react';
import '@trendmicro/react-sidenav/dist/react-sidenav.css';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import SideDrawer from 'components/Menu/SideDrawer';
import TopBar from 'components/Menu/TopBar';

import CssBaseline from '@mui/material/CssBaseline';

import withStyles from '@mui/styles/withStyles';
import DialogBox from 'components/Dialog/DialogBox';
import { getRoutes } from './Routes/index';
import { connect } from 'react-redux';

import { isAuthenticated } from 'features/Login/LoginAction';
import { Colors } from 'config/StyleConfig';
import { useStitches } from 'theme';

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1,
    position: 'relative',
  },
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
});

function DefaultContainer({ privateRoutes }) {
  const { css } = useStitches();

  return (
    <div
      className={css({
        height: '$screen-h',
        width: '$full',
        overflow: 'hidden',
        layout: 'row',
      })}
    >
      {/* <div
        style={{
          position: 'fixed',
          width: '100%',
          height: '100%',
          zIndex: -99999,
          backgroundColor: Colors.background,
        }}
      /> */}

      <CssBaseline />
      <aside className={css({ flexShrink: 0, zIndex: 0 })}>
        <SideDrawer />
      </aside>
      <div
        className={css({
          layout: 'stack',
          flex: 1,
          overflow: 'hidden',
          zIndex: 0,
        })}
      >
        <div>
          <TopBar />
        </div>
        <div
          className={css({
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            p: '$scale600',
          })}
        >
          <DialogBox />
          <Routes>{privateRoutes}</Routes>
        </div>
      </div>
    </div>
  );
}

function App(props) {
  const { isUserAuthenticated } = props;
  const routes = getRoutes();

  useEffect(() => {
    isUserAuthenticated();
  }, [isUserAuthenticated]);

  return (
    <Router>
      <Routes>
        {routes.publicRoutes}
        <Route
          path="*"
          element={<DefaultContainer privateRoutes={routes.privateRoutes} />}
        />
      </Routes>
    </Router>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    isUserAuthenticated: () => dispatch(isAuthenticated()),
  };
};

const mapStateToProps = state => {
  return {
    authenticated: state.LoginReducer.authenticated,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(App));
